import { gql } from "@apollo/client";

export const GET_ADMIN_INDICACION_INDICACIONES = gql`
    query GetAdminIndicacionIndicaciones($idIndicacionAprobacion: Int!) {
  adminIndicacionIndicaciones(idIndicacionAprobacion: $idIndicacionAprobacion) {
    success,
    error,
    valorEsperado {
      indicaciones {
        idIndicacion,
        periodo,
        proporcionDiaria,
        insumos {
          nombre,
          cantidadDiaria,
          cantidadPresentacion,
          unidad,
          costoUnidad,
          costoTotal,
          presentacion,
          proporcionDiaria,
          proporcionDiariaTotal
        }
      },
      indicacionSolicitada {
        idIndicacionAprobacion,
        periodoSolicitud,
        proporcionDiariaSolicitud,
        solicitante,
        observacionSolicitante,
        idEstadoMedico,
        estadoMedico,
        observacionMedico,
        idEstadoComercial,
        estadoComercial,
        observacionComercial,
        insumos {
          nombre,
          cantidadDiaria,
          cantidadPresentacion,
          unidad,
          costoUnidad,
          costoTotal,
          presentacion,
          proporcionDiaria,
          proporcionDiariaTotal
        }
      }
    }
  }
}
`;